// extracted by mini-css-extract-plugin
export default {"tableContainer":"DashboardPassportFileTable_tableContainer__nTEV-","fileTable":"DashboardPassportFileTable_fileTable__rDVFf","noData":"DashboardPassportFileTable_noData__90YMz"};